import { useEffect } from 'react';

/**
 * A Save button that does not take focus (or stops mousedown) never blurs the
 * editor, so a pending debounced edit would still be unwritten when its click
 * handler reads the form. Run `flush` on any press outside the editor, in capture
 * phase so it lands before the target's own handlers.
 */
export function useFlushOnOutsidePress(getEditorDom: (() => Element | null) | null, flush: () => void) {
	useEffect(() => {
		if (!getEditorDom) return undefined;
		const flushOutside = (event: Event) => {
			const dom = getEditorDom();
			if (dom && event.composedPath().includes(dom)) return;
			flush();
		};
		document.addEventListener('mousedown', flushOutside, true);
		return () => document.removeEventListener('mousedown', flushOutside, true);
	}, [getEditorDom, flush]);
}
